import React from "react";
import Footer2 from "components/Footers/Footer2";
import AdminNavbar from "components/Navbars/AdminNavbar";

import bgg from "assets/img/bgg.png";

import teaching from "assets/img/new/way/teaching.jpeg";

import modality from "assets/img/new/way/modality.png";
import curriculam1 from "assets/img/curriculum1.png";
import technologyyy from "assets/img/technologyyy.jpg";

export default function Entrepreneurial() {
  return (
    <>
      <AdminNavbar />
      <section
        className=" xl:block lg:block md:block sm:hidden hidden"
        style={{
          backgroundColor: "#f0f7fa",
          backgroundImage: `url(${bgg})`,
          backgroundPosition: "center center",
          backgroundRepeat: "repeat",
          backgroundSize: "35% auto",
        }}
      >
        <div className="text-center justify-center xl:w-11/12 lg:w-11/12 md:w-11/12 w-12/12  md:pt-24 md:pb-20 lg:pt-28 lg:pb-20 xl:pt-36 xl:pb-32 mx-auto xl:mt-0 lg:mt-0 md:mt-12">
          {/* <h6 className="text-peach font-semibold pt-2 text-center xl:text-lg lg:text-lg text-lg bubblegum">
            Way of Learning
          </h6> */}
          <h1
            className="text-black xl:text-6xl lg:text-4xl md:text-3xl font-semibold xl:pt-1 "
            style={{ lineHeight: 1.4 }}
          >
            Antah Prerana - Way of Learning
          </h1>
          <h6 className="text-blue font-semibold pt-2 text-center xl:text-3xl lg:text-3xl text-3xl">
          Curriculum designed by Award Winning Educationists
          </h6>

          <p className="xl:pt-4 pt-2 text-center xl:px-36 lg:px-32">
            Antah:Prerana’s forward-thinking pedagogy forms a key partnership
            with Junior Toes, blending timeless educational values with
            innovative, contemporary approaches. The curriculum, crafted by
            nationally and internationally recognized curriculum designers,
            ensures a rich, relevant, and comprehensive learning experience.
            This collaboration creates an enriching environment that promotes
            curiosity, creativity, and critical thinking among young learners.
            With a clear vision of preparing children for a VUCA (Volatile,
            Uncertain, Complex, and Ambiguous) world, the curriculum equips them
            with essential skills and a mindset to thrive in a rapidly changing
            global landscape.
          </p>
          <p className="xl:pt-2 pt-2 text-center xl:px-36 lg:px-32">
            By combining play-based learning with progressive teaching methods,
            this partnership helps children not only excel academically but also
            navigate future challenges with confidence, adaptability, and
            leadership.
          </p>
        </div>
      </section>

      <section className="xl:py-12 container mx-auto parkinsans xl:px-0 lg:px-4 md:px-4 px-4 xl:block lg:block md:block sm:hidden hidden">
        {/* <div className="xl:py-12 lg:py-12 md:py-12">
          <div className="flex items-center">
            <div
              className="xl:w-9/12 xl:py-12 py-12 xl:px-8 lg:w-9/12 md:w-10/12 lg:px-8 md:px-6"
              style={{
                background: "#F1E1C8",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" xl:text-7xl lg:text-6xl md:text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                01
              </p>
              <h1 className="text-black xl:text-3xl text-3xl pt-2 font-semibold xl:pt-3">
                An Award Winning Curriculum
              </h1>
              
              <p className="xl:pt-4 xl:w-11/12 pt-2 lg:w-11/12 md:w-11/12">
                Antah:Prerana’s forward-thinking pedagogy forms a key
                partnership with Junior Toes, blending timeless educational
                values with innovative, contemporary approaches. The curriculum,
                crafted by nationally and internationally recognized curriculum
                designers, ensures a rich, relevant, and comprehensive learning
                experience. This collaboration creates an enriching environment
                that promotes curiosity, creativity, and critical thinking among
                young learners. With a clear vision of preparing children for a
                VUCA (Volatile, Uncertain, Complex, and Ambiguous) world, the
                curriculum equips them with essential skills and a mindset to
                thrive in a rapidly changing global landscape.
              </p>
              <p className="xl:pt-2 xl:w-11/12 pt-2 lg:w-11/12 md:w-11/12">
                By combining play-based learning with progressive teaching
                methods, this partnership helps children not only excel
                academically but also navigate future challenges with
                confidence, adaptability, and leadership.
              </p>
            </div>
            <div
              className="xl:w-4/12 lg:w-4/12 md:w-4/12 bg-white rounded  xl:-ml-16 lg:-ml-8 md:-ml-8"
              style={{ border: "1px solid #ccc" }}
            >
              <img src={award} alt="" />
            </div>
          </div>
        </div> */}

        <div className="xl:py-12 py-12">
          <div className="flex items-center">
            <div
              className="xl:w-4/12 lg:w-4/12 md:w-4/12 lg:-mr-4 md:-mr-4 bg-white rounded  xl:-mr-10 z-50"
              style={{ border: "1px solid #ccc" }}
            >
              <img src={teaching} alt="" />
            </div>
            <div
              className="xl:w-9/12 xl:py-12 xl:px-8 xl:pl-16 py-12 lg:px-8 md:px-6 w-10/12 "
              style={{
                background: "#D6D1C7",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" xl:text-7xl lg:text-6xl md:text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                01
              </p>
              <h1 className="text-black xl:text-3xl text-3xl pt-2 font-semibold xl:pt-3">
                Curriculum and Teaching Methodology
              </h1>
              <p className="xl:pt-4 pt-4 ">
                Our entrepreneurial preschool programme is built on six engaging
                themes and seven creative domains, each carefully designed to
                foster developmentally ageappropriate skills. These themes focus
                on building key entrepreneurial skills like leadership,
                teamwork, and financial literacy, while nurturing creativity,
                problemsolving, and critical thinking.
              </p>
              <p className="xl:pt-4 pt-4 ">
                Every lesson is delivered through fun, play-based activities
                that ensure meaningful outcomes. Children engage in hands-on
                exploration, guided by award-winning pedagogy, to develop
                essential life skills while embracing their individuality. Our
                approach empowers little ones to think independently,
                collaborate effectively, and grow into confident learners ready
                to take on the world. A curriculum created for living and
                excelling in the future
              </p>
            </div>
          </div>
        </div>

        <div className="xl:py-12 py-12">
          <div className="flex items-center">
            <div
              className="xl:w-9/12 xl:py-12 xl:px-8 w-10/12 lg:px-8 md:px-6 py-12"
              style={{
                background: "#F4CDBE",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" xl:text-7xl lg:text-6xl md:text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                02
              </p>
              <h1 className="text-black xl:text-3xl text-3xl pt-2 font-semibold xl:pt-3">
                Entrepreneurial Skills
              </h1>
              <h3 className="text-gray-500 xl:text-base xl:w-9/12 font-semibold xl:pt-3 w-12/12">
                "Plant the seeds of leadership, teamwork, and financial wisdom
                early—because even the smallest hands can shape a brighter
                future."
              </h3>
              <p className="xl:pt-4 xl:w-11/12 w-11/12 ">
                Antah:Prerana’s learning model believes that nurturing
                entrepreneurial skills is crucial to developing future leaders.
                Through age-appropriate activities, the programme incorporates
                leadership, teamwork, and financial literacy. Children engage in
                group projects, taking on roles that build communication and
                leadership skills.
              </p>
              <p className="xl:pt-4 xl:w-11/12 w-11/12">
                The programme introduces foundational financial concepts, such
                as budgeting, saving, and trading, through engaging pretend play
                and hands-on activities. This approach empowers children to
                become independent, confident thinkers, well-prepared to
                navigate their future with a strong sense of entrepreneurship.
              </p>
            </div>
            <div
              className="xl:w-4/12 lg:w-4/12 md:w-4/12 bg-white rounded  xl:-ml-16 lg:-ml-8 md:-ml-8"
              style={{ border: "1px solid #ccc" }}
            >
              <img src={curriculam1} alt="" />
            </div>
          </div>
        </div>

        <div className="xl:py-12 py-12">
          <div className="flex items-center">
            <div
              className="xl:w-4/12 lg:w-4/12 md:w-4/12 bg-white rounded  xl:-mr-10 lg:-mr-4 md:-mr-4 z-50"
              style={{ border: "1px solid #ccc" }}
            >
              <img src={technologyyy} alt="" />
            </div>
            <div
              className="xl:w-9/12 xl:py-12 xl:px-8 xl:pl-16 w-10/12 lg:px-8 md:px-6 py-12"
              style={{
                background: "#E9E3DA",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" xl:text-7xl lg:text-6xl md:text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                03
              </p>
              <h1 className="text-black xl:text-3xl text-3xl pt-2 font-semibold xl:pt-3">
                Technology of Consciousness
              </h1>
              <h3 className="text-gray-500 xl:text-base xl:w-9/12 pt-2 w-12/12 font-semibold xl:pt-3">
                “True technology lies in awakening young minds to explore,
                question, and connect with the world all through their
                consciousness"
              </h3>
              <p className="xl:pt-4 pt-4 ">
                Central to Antah:Prerana’s philosophy is the technology of
                consciousness, which fosters mindfulness, self-awareness, and
                emotional intelligence through the full use of the five senses.
                By engaging children in sensory-rich activities that stimulate
                sight, sound, touch, taste, and smell, they develop a deeper
                connection to their surroundings. These experiences enhance
                emotional regulation, decision-making, and problem-solving,
                helping children stay present and engaged.
              </p>
              <p className="xl:pt-4 pt-4 ">
                Activities like listening to calming music, exploring textures,
                and connecting with nature allow children to reflect on their
                thoughts and emotions, nurturing resilience and thoughtful
                action.
              </p>
            </div>
          </div>
        </div>

        <div className="xl:py-12 py-12">
          <div className="flex items-center">
            <div
              className="xl:w-9/12 xl:py-12 xl:px-8 py-12 w-10/12 lg:px-8 md:px-6"
              style={{
                background: "#FEFACF",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" xl:text-7xl lg:text-6xl md:text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                04
              </p>
              <h1 className="text-black xl:text-3xl text-3xl pt-2 font-semibold xl:pt-3">
                Modality of Consciousness
              </h1>
              <h3 className="text-gray-500 xl:text-base xl:w-9/12 w-12/12 font-semibold xl:pt-3">
                "When children explore through multiple lenses—artistic,
                scientific, cultural, and beyond—they discover that every
                perspective is a doorway to deeper understanding."
              </h3>
              <p className="xl:pt-4 xl:w-11/12 pt-4 w-11/12 ">
                In Antah:Prerana’s pedagogy, the modality of consciousness
                encourages children to explore different perspectives and ways
                of thinking. By exposing them to diverse viewpoints in art,
                science, language, and culture, children build a
                multi-dimensional understanding of the world. The approach
                encourages them to challenge assumptions, engage with new ideas,
                and reflect on their experiences.
              </p>
              <p className="xl:pt-4 xl:w-11/12 pt-4 w-11/12">
                This promotes creativity and critical thinking, equipping
                children with the flexibility needed to adapt to various
                situations—key skills for problem-solving and entrepreneurial
                thinking in the future.
              </p>
            </div>
            <div
              className="xl:w-4/12 lg:w-4/12 md:w-4/12 bg-white rounded  xl:-ml-16 lg:-ml-8 md:-ml-8"
              style={{ border: "1px solid #ccc" }}
            >
              <img src={modality} alt="" />
            </div>
          </div>
        </div>
      </section>

      {/* mobile view */}

      {/* mobilebanner */}
      <section
        className=" xl:hidden lg:hidden md:hidden sm:block block mt-18"
        style={{
          backgroundColor: "#f0f7fa",
          // backgroundImage: `url(${banner})`,
          // backgroundPosition: "center center",
          // backgroundRepeat: "no-repeat",
          // backgroundSize: "100% auto",
        }}
      >
        <div className="text-center justify-center  pt-16 pb-16 px-4">
          <h1
            className="text-black text-2xl font-semibold xl:pt-1 "
            style={{ lineHeight: 1.4 }}
          >
            Antah Prerana - Way of Learning
          </h1>
          <h6 className="text-blue font-semibold pt-2 text-center text-xl">
          Curriculum designed by Award Winning Educationists
          </h6>
          <p className="pt-4  ">
            Antah:Prerana’s forward-thinking pedagogy forms a key partnership
            with Junior Toes, blending timeless educational values with
            innovative, contemporary approaches. The curriculum, crafted by
            nationally and internationally recognized curriculum designers,
            ensures a rich, relevant, and comprehensive learning experience.
            This collaboration creates an enriching environment that promotes
            curiosity, creativity, and critical thinking among young learners.
            With a clear vision of preparing children for a VUCA (Volatile,
            Uncertain, Complex, and Ambiguous) world, the curriculum equips them
            with essential skills and a mindset to thrive in a rapidly changing
            global landscape.
          </p>
          <p className="pt-2  ">
            By combining play-based learning with progressive teaching methods,
            this partnership helps children not only excel academically but also
            navigate future challenges with confidence, adaptability, and
            leadership.
          </p>
        </div>
      </section>

      <section className="xl:hidden lg:hidden md:hidden sm:block block">
        {/* <div className="w-12/12 px-4 mt-12">
          <div className=" ">
            <div
              className="w-12/12 py-12 p-4"
              style={{
                background: "#F1E1C8",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                01
              </p>
              <h1 className="text-black text-2xl pt-2 font-semibold ">
                An Award Winning Curriculum
              </h1>

              <p className="pt-4 text-justify ">
                Antah:Prerana’s forward-thinking pedagogy forms a key
                partnership with Junior Toes, blending timeless educational
                values with innovative, contemporary approaches. The curriculum,
                crafted by nationally and internationally recognized curriculum
                designers, ensures a rich, relevant, and comprehensive learning
                experience. This collaboration creates an enriching environment
                that promotes curiosity, creativity, and critical thinking among
                young learners. With a clear vision of preparing children for a
                VUCA (Volatile, Uncertain, Complex, and Ambiguous) world, the
                curriculum equips them with essential skills and a mindset to
                thrive in a rapidly changing global landscape.
              </p>

              <p className="pt-2 text-justify ">
                By combining play-based learning with progressive teaching
                methods, this partnership helps children not only excel
                academically but also navigate future challenges with
                confidence, adaptability, and leadership.
              </p>
            </div>
            <div
              className="w-12/12 bg-white rounded "
              style={{ border: "1px solid #ccc" }}
            >
              <img src={award} alt="" />
            </div>
          </div>
        </div> */}

        <div className="w-12/12 px-4 mt-12">
          <div className=" ">
            <div
              className="w-12/12 py-12 p-4"
              style={{
                background: "#D6D1C7",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                01
              </p>
              <h1 className="text-black text-2xl pt-2 font-semibold ">
                Curriculum and Teaching Methodology
              </h1>

              <p className="pt-4  ">
                Our entrepreneurial preschool programme is built on six engaging
                themes and seven creative domains, each carefully designed to
                foster developmentally ageappropriate skills. These themes focus
                on building key entrepreneurial skills like leadership,
                teamwork, and financial literacy, while nurturing creativity,
                problemsolving, and critical thinking.
              </p>

              <p className="pt-2  ">
                Every lesson is delivered through fun, play-based activities
                that ensure meaningful outcomes. Children engage in hands-on
                exploration, guided by award-winning pedagogy, to develop
                essential life skills while embracing their individuality. Our
                approach empowers little ones to think independently,
                collaborate effectively, and grow into confident learners ready
                to take on the world. A curriculum created for living and
                excelling in the future
              </p>
            </div>
            <div
              className="w-12/12 bg-white rounded "
              style={{ border: "1px solid #ccc" }}
            >
              <img src={teaching} alt="" />
            </div>
          </div>
        </div>

        <div className="w-12/12 px-4 mt-12">
          <div className=" ">
            <div
              className="w-12/12 py-12 p-4"
              style={{
                background: "#F4CDBE",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                02
              </p>
              <h1 className="text-black text-2xl pt-2 font-semibold ">
                Entrepreneurial Skills
              </h1>
              <h3 className="text-gray-500 pt-2 font-semibold">
                "Plant the seeds of leadership, teamwork, and financial wisdom
                early—because even the smallest hands can shape a brighter
                future."
              </h3>

              <p className="pt-4  ">
                Antah:Prerana’s learning model believes that nurturing
                entrepreneurial skills is crucial to developing future leaders.
                Through age-appropriate activities, the programme incorporates
                leadership, teamwork, and financial literacy. Children engage in
                group projects, taking on roles that build communication and
                leadership skills.
              </p>

              <p className="pt-2 ">
                The programme introduces foundational financial concepts, such
                as budgeting, saving, and trading, through engaging pretend play
                and hands-on activities. This approach empowers children to
                become independent, confident thinkers, well-prepared to
                navigate their future with a strong sense of entrepreneurship.
              </p>
            </div>
            <div
              className="w-12/12 bg-white rounded "
              style={{ border: "1px solid #ccc" }}
            >
              <img src={curriculam1} alt="" />
            </div>
          </div>
        </div>

        <div className="w-12/12 px-4 mt-12">
          <div className=" ">
            <div
              className="w-12/12 py-12 p-4"
              style={{
                background: "#E9E3DA",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                03
              </p>
              <h1 className="text-black text-2xl pt-2 font-semibold ">
                Technology of Consciousness
              </h1>
              <h3 className="text-gray-500 pt-2 font-semibold">
                “True technology lies in awakening young minds to explore,
                question, and connect with the world all through their
                consciousness"
              </h3>

              <p className="pt-4  ">
                Central to Antah:Prerana’s philosophy is the technology of
                consciousness, which fosters mindfulness, self-awareness, and
                emotional intelligence through the full use of the five senses.
                By engaging children in sensory-rich activities that stimulate
                sight, sound, touch, taste, and smell, they develop a deeper
                connection to their surroundings. These experiences enhance
                emotional regulation, decision-making, and problem-solving,
                helping children stay present and engaged.
              </p>

              <p className="pt-2  ">
                Activities like listening to calming music, exploring textures,
                and connecting with nature allow children to reflect on their
                thoughts and emotions, nurturing resilience and thoughtful
                action.
              </p>
            </div>
            <div
              className="w-12/12 bg-white rounded "
              style={{ border: "1px solid #ccc" }}
            >
              <img src={technologyyy} alt="" />
            </div>
          </div>
        </div>

        <div className="w-12/12 px-4 mt-12">
          <div className=" ">
            <div
              className="w-12/12 py-12 p-4"
              style={{
                background: "#FEFACF",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                04
              </p>
              <h1 className="text-black text-2xl pt-2 font-semibold ">
                Modality of Consciousness
              </h1>
              <h3 className="text-gray-500 pt-2 font-semibold">
                "When children explore through multiple lenses—artistic,
                scientific, cultural, and beyond—they discover that every
                perspective is a doorway to deeper understanding."
              </h3>

              <p className="pt-4  ">
                In Antah:Prerana’s pedagogy, the modality of consciousness
                encourages children to explore different perspectives and ways
                of thinking. By exposing them to diverse viewpoints in art,
                science, language, and culture, children build a
                multi-dimensional understanding of the world. The approach
                encourages them to challenge assumptions, engage with new ideas,
                and reflect on their experiences.
              </p>

              <p className="pt-2  ">
                This promotes creativity and critical thinking, equipping
                children with the flexibility needed to adapt to various
                situations—key skills for problem-solving and entrepreneurial
                thinking in the future.
              </p>
            </div>
            <div
              className="w-12/12 bg-white rounded "
              style={{ border: "1px solid #ccc" }}
            >
              <img src={modality} alt="" />
            </div>
          </div>
        </div>
      </section>

      <Footer2 />
    </>
  );
}
